import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

export default {
  namespaced: true,
  state: {
    sector: [],
    clasificacion: [],
    arreglar: [],
    genero: [],
    estadoCivil: [],
    nacionEstado: [],
    estadoStatus: [],
    departamentoDistrito: [],
  },
  getters: {
    Sector(state) {
      return state.sector;
    },

    Clasificacion(state) {
      return state.clasificacion;
    },

    Arreglar(state) {
      return state.arreglar;
    },

    Genero(state) {
      return state.genero;
    },

    EstadoCiviles(state) {
      return state.estadoCivil;
    },

    PaisEstado(state) {
      return state.paisEstado;
    },

    NacionEstado(state) {
      return state.nacionEstado;
    },

    EstadoStatus(state) {
      return state.estadoStatus;
    },

    DepartamentoDistrito(state) {
      return state.departamentoDistrito;
    },
  },
  mutations: {
    llenarSector(state, data) {
      state.sector = data;
    },

    llenarClasificacion(state, data) {
      state.clasificacion = data;
    },

    llenarArreglar(state, data) {
      state.arreglar = data;
    },

    llenarGenero(state, data) {
      state.genero = data;
    },

    llenarEstadoCiviles(state, data) {
      state.estadoCivil = data;
    },

    llenarPaisEstado(state, data) {
      state.paisEstado = data;
    },

    llenarNacionEstado(state, data) {
      state.nacionEstado = data;
    },

    llenarEstadoStatus(state, data) {
      state.estadoStatus = data;
    },

    llenarDepartamentoDistrito(state, data) {
      state.departamentoDistrito = data;
    },
  },

  actions: {
    async ParametrosUsers({ commit }) {
      let response = await axios.get("ParametroData/Parametro/7540");
      commit("llenarSector", response.data);

      let r = await axios.get("ParametroData/Parametro/7546");
      commit("llenarClasificacion", r.data);

      await axios.get("ParametroData/Parametro/1").then((datos) => {
        // console.log(datos.data);
        commit("llenarArreglar", datos.data);
      });

      await axios.get("ParametroData/Parametro/64").then((datos) => {
        commit("llenarGenero", datos.data);
      });

      await axios.get("ParametroData/Parametro/69").then((datos) => {
        // console.log(datos.data);
        commit("llenarEstadoCiviles", datos.data);
      });

      await axios.get("ParametroData/Parametro/75").then((datos) => {
        // console.log(datos.data);
        commit("llenarPaisEstado", datos.data);
      });

      await axios.get("ParametroData/Parametro/2405").then((datos) => {
        // console.log(datos.data);
        commit("llenarNacionEstado", datos.data);
      });

      await axios.get("ParametroData/Parametro/2421").then((datos) => {
        // console.log(datos.data);
        commit("llenarEstadoStatus", datos.data);
      });

      await axios.get("ParametroData/Parametro/350").then((datos) => {
        commit("llenarDepartamentoDistrito", datos.data);
      });

      
      
    },
  },
  modules: {},
};
